import {Component, OnDestroy, OnInit} from '@angular/core';
import {CustomerService} from '../../../services/customers.service';
import {Subject} from 'rxjs/Subject';
import {ActivatedRoute, Router} from '@angular/router';
import {Customer} from '../../../models/customer.model';

@Component({
  providers: [CustomerService],
  styleUrls: ['./customer.edit.component.scss'],
  selector: 'app-customers-edit',
  templateUrl: './customer.edit.component.html',
})
export class CustomerEditComponent implements OnDestroy, OnInit {
  public customer: Customer;
  public error: string;

  private _ngUnSubscribe: Subject<void> = new Subject<void>();

  constructor(private _route: ActivatedRoute,  public router: Router,
              private _customerService: CustomerService) {}

  public ngOnInit() {
    this._route.params
      .takeUntil(this._ngUnSubscribe)
      .subscribe(params => {
        const customerId = params['id'];

        if (customerId) {
          this._customerService.load(customerId);
          this._customerService.customers$
            .takeUntil(this._ngUnSubscribe)
            .subscribe(
              customers => {
                this.customer = customers.find(pr => pr._id === customerId);
              }
            );
        }
      });
  }

  public ngOnDestroy() {
    this._ngUnSubscribe.next();
    this._ngUnSubscribe.complete();
  }

  public saveCustomer(): void {
    if (this.customer.name !== '') {
      this._customerService.update(this.customer)
        .subscribe(customer => {
          this.router.navigate(['/customers', this.customer._id]);
        });
    } else {
      this.error = 'Naam is verplicht.';
    }
  }

  public cancel(): void {
    this.router.navigate(['/customers', this.customer._id]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/customer/edit/customer.edit.component.ts